<script setup lang="ts">
import { useField } from 'vee-validate';

const props = defineProps<{
  name: string;
  label: string;
  disabled?: boolean;
  prefix?: string;
  hint?: string;
  min?: number;
  max?: number;
  type?:
    | 'text'
    | 'password'
    | 'textarea'
    | 'email'
    | 'search'
    | 'tel'
    | 'file'
    | 'number'
    | 'url'
    | 'time'
    | 'date'
    | 'datetime-local'
    | undefined;
  clearable?: boolean;
}>();
const { value: value, errorMessage: errorMessage } = useField<string>(props.name);
</script>

<template>
  <q-input
    class="standard-input"
    v-model="value"
    :label="props.label"
    v-bind="$attrs"
    :error="!!errorMessage"
    :error-message="errorMessage"
    :disable="disabled"
    :type="type"
    :prefix="props.prefix"
    :hint="props.hint"
    :min="props.min"
    :max="props.max"
    :class="{ 'standard-input-hint': !!props.hint }"
    :clearable="props.clearable"
  />
</template>
<style lang="scss">
.standard-input-hint {
  margin-bottom: 20px;
}
</style>
